<div class="copo-datacenter-filter">
	<label class="filter-number-label" for="filter-order-number-reference-input" translate>filter.order-number.reference</label>
	<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
		<input matInput id="filter-order-number-reference-input" type="text" spellcheck="false" autocomplete="off" [formControl]="referenceTextControl" [placeholder]="('filter.order-number.reference' | translate) + '...'">
		<button type="button" *ngIf="referenceTextControl.value" matSuffix mat-icon-button (click)="resetReference()" tabindex="-1">
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</mat-form-field>
	<label class="filter-number-label" for="filter-order-number-item-input" translate>filter.order-number.item</label>
	<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
		<input matInput id="filter-order-number-item-input" type="text" spellcheck="false" autocomplete="off" [formControl]="itemTextControl" [placeholder]="('filter.order-number.item' | translate) + '...'">
		<button type="button" *ngIf="itemTextControl.value" matSuffix mat-icon-button (click)="resetItem()" tabindex="-1">
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</mat-form-field>
</div>
